<template>
  <el-row :class="{ 'full-height': !mobile }">
    <el-row class="header-container flex-center">
      <div>
        <a href="/">
          <el-image
            src="/static/img/head-view/logo.png"
            style="width: 234px; height: 49px; vertical-align: middle"
          ></el-image>
        </a>
        <span v-for="(item, index) in menus">
          <span
            v-if="item.parentId == -1"
            :class="{ 'menu-active': index == activeIndex }"
            @mouseenter="showMenuItem(item, index)"
          >
            <a
              v-if="item.isOut == 1"
              target="_blank"
              class="first-menu"
              :href="item.url"
              >{{ item.nameZh }}</a
            >
            <span v-else class="first-menu">{{ item.nameZh }}</span>
          </span>
        </span>
      </div>
    </el-row>
    <div class="banner-container">
      <el-row class="second-menu flex-center">
        <span v-for="(item, index) in hoverMenu.children">
          <span v-if="item.parentId != -1" @mouseenter="activeMenuItem(item)">
            <a
              :class="{
                'menu-active': activeMenuItemId == item.id,
                'menu-item': true,
              }"
              v-if="item.isOut == 1"
              :href="item.url"
              >{{ item.nameZh }}</a
            >
            <a
              :class="{
                'menu-active': activeMenuItemId == item.id,
                'menu-item': true,
              }"
              v-else
              :href="'/detail?id=' + item.id + '&pid=' + item.parentId"
              >{{ item.nameZh }}</a
            >
            <span
              v-if="index != hoverMenu.children.length - 1"
              style="margin-left: 10px; margin-right: 10px"
              >|</span
            >
          </span>
        </span>
      </el-row>
      <div id="banner" style="height: 100% ;">
        <div
          :class="{ 'swiper-container': true, 'mb-swiper-container': mobile }"
        >
          <div class="swiper-wrapper">
            <div
              :class="{ rightDownBig: index == 0, 'swiper-slide': true }"
              v-for="(item, index) in banners"
            >
              <a :href="item.link">
                <img :src="item.img" style="height: 100%; width: 100%" />
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="swiper-pagination"></div> -->
      </div>
    </div>
  </el-row>
</template>

<script>
import api from "@/http/common";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  name: "Header",
  components: {
    Swiper,
  },
  data() {
    return {
      activeIndex: null,
      activeMenuItemId: null,
      menus: [],
      banners: [{}],
      hoverMenu: {},
      mobile: false,
    };
  },
  mounted() {
    // let trList=['leftUp','moveRight','moveDown','centerBig','rightDownBig'];
    let trList = [
      "centerBig",
      "centerBig",
      "centerBig",
      "centerBig",
      "centerBig",
    ];
    var swiper = new Swiper("#banner .swiper-container", {
      observer: true,
      observeParents: true,
      speed: 500,
      autoplay: 6000,
      autoplayDisableOnInteraction: false,
      effect: "fade",
      pagination: ".swiper-pagination",
      paginationClickable: true,
      onSlideChangeStart: function (swiper) {
        let nextSlide = swiper.slides.eq(swiper.activeIndex);
        nextSlide.addClass(trList[Math.floor(Math.random() * 5)]);
      },
      onSlideChangeEnd: function (swiper) {
        let prevSlide = swiper.slides[swiper.previousIndex];
        prevSlide.className = "swiper-slide";
      },
    });
  },
  methods: {
    showMenuItem(menuItem, itemIndex) {
      this.hoverMenu = menuItem;
      this.activeIndex = itemIndex;
      this.activeMenuItemId = null;
    },
    activeMenuItem(childrenItem) {
      this.activeMenuItemId = childrenItem.id;
    },
    getMenu() {
      const _this = this;
      api.getMenu().then((res) => {
        _this.menus = res.content;
        _this.$emit("menuChange", _this.menus);
      });
    },
    getBanners() {
      const _this = this;
      api.getBanners().then((res) => {
        _this.banners = res;
      });
    },
    isMobile() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.mobile = true;
      } else {
        this.mobile - false;
      }

      console.log("是否为移动端 : ", this.mobile);
    },
  },
  created() {
    this.getMenu();
    this.getBanners();
    this.isMobile();
  },
};
</script>

<style scoped>
.header-container {
  height: 90px;
  background: #980f25;
}

.first-menu {
  width: 36px;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-left: 46px;
  text-decoration: none;
  cursor: pointer;
}

.menu-item {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}

.banner-container {
  height: calc(100% - 90px);
}

.second-menu {
  position: absolute;
  height: 60px;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  z-index: 999;
}

.second-menu > span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.menu-active {
  color: #ffc880 !important;
}

.menu-active > * {
  color: #ffc880 !important;
}

.first-menu:visited {
  color: #ffffff;
}

.menu-item:visited {
  color: #ffffff;
}

.swiper-container {
  /* width: 1750px; */
  /* height: 523px; */
  width: 100%;
  height: 100%;
  /* position: absolute; */
  /* left: -875px; */
  left: -50%;
  margin-left: 50%;
}

.mb-swiper-container {
  height: 428px !important;
}

.swiper-slide .detail {
  height: 90px;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  width: 100%;
  bottom: 0;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s 0.3s;
}

.swiper-slide-active .detail {
  opacity: 1;
}

.swiper-slide .detail h3 {
  width: 950px;
  margin: 15px auto 0;
}

.swiper-slide .detail p {
  width: 950px;
  margin: 5px auto 0;
}

.swiper-slide .detail p span {
  width: 650px;
  display: block;
}

/**/
.effect1 img {
  transform: scale(1.25, 1.25) translate(10%, 10%);
  transform: scale(1.1, 1.1) translate(4.545%, 4.545%);
  /*tr     =    (sc-1)/2sc*100%              */
  /* --1.25       0.25/2.5*100%=10%          */
}

.leftUp img {
  -webkit-animation-name: leftUp;
  animation-name: leftUp;
}

@-webkit-keyframes leftUp {
  0% {
    transform: scale(1.1, 1.1) translate(4.545%, 4.545%);
  }

  100% {
    transform: scale(1.1, 1.1) translate(-4.545%, -4.545%);
  }
}

@keyframes leftUp {
  0% {
    transform: scale(1.1, 1.1) translate(4.545%, 4.545%);
  }

  100% {
    transform: scale(1.1, 1.1) translate(-4.545%, -4.545%);
  }
}

.moveRight img {
  -webkit-animation-name: moveRight;
  animation-name: moveRight;
}

@-webkit-keyframes moveRight {
  0% {
    transform: scale(1.1, 1.1) translate(-4.545%, 0);
  }

  100% {
    transform: scale(1.1, 1.1) translate(4.545%, 0);
  }
}

@keyframes moveRight {
  0% {
    transform: scale(1.1, 1.1) translate(-4.545%, 0);
  }

  100% {
    transform: scale(1.1, 1.1) translate(4.545%, 0);
  }
}

.moveDown img {
  -webkit-animation-name: moveDown;
  animation-name: moveDown;
}

@-webkit-keyframes moveDown {
  0% {
    transform: scale(1.1, 1.1) translate(0, -4.545%);
  }

  100% {
    transform: scale(1.1, 1.1) translate(0, 4.545%);
  }
}

@keyframes moveDown {
  0% {
    transform: scale(1.1, 1.1) translate(0, -4.545%);
  }

  100% {
    transform: scale(1.1, 1.1) translate(0, 4.545%);
  }
}

.centerBig img {
  -webkit-animation-name: centerBig;
  animation-name: centerBig;
}

@-webkit-keyframes centerBig {
  100% {
    transform: scale(1.1, 1.1);
  }
}

@keyframes centerBig {
  100% {
    transform: scale(1.1, 1.1);
  }
}

.rightDownBig img {
  -webkit-animation-name: rightDownBig;
  animation-name: rightDownBig;
}

@-webkit-keyframes rightDownBig {
  100% {
    transform: scale(1.1, 1.1) translate(4%, 4%);
  }
}

@keyframes rightDownBig {
  100% {
    transform: scale(1.1, 1.1) translate(4%, 4%);
  }
}

.swiper-slide img {
  animation-duration: 5s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 5s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-fill-mode: forwards;
}

.swiper-pagination {
  bottom: 35px;
  right: 250px;
}

.swiper-pagination-bullet {
  width: 20px;
  height: 20px;
  background: #fff;
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue